import React from 'react'
import {
  Grid,
  Lists,
  Box,
  Slide,
  Spacer,
  HeaderPrimary,
  SpacedDivider
} from '@fedsim/components'
import { SPACING } from '@fedsim/constants'
import { groupBy } from '@fedsim/helpers'
import { SpacedPaper } from '@fedsim/components'

import { ImportedReady } from 'icons'
import ImportBrandButton from 'components/buttons/import-brand'

const listProps = {
  searchEnabled: false,
  groupName: 'Brand',
  toggleListType: true,
  defaultListType: 'avatar',
  perPage: 16,
}

function PrimaryCollection({ collection, actions }) {
  const byCompany = groupBy(collection, 'company');
  // const sortFn = (a, b) => byCompany[b].length - byCompany[a].length
  const byCompanySortedByLength = Object.keys(byCompany)//.sort(sortFn);

  return (
    <>
      {byCompanySortedByLength.map((company) => {
        const collection = byCompany[company];
        return (
          <React.Fragment key={company}>
            <SpacedPaper>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}>
                <HeaderPrimary>{company}</HeaderPrimary>
                <ImportBrandButton id={company} />
              </Box>
              <SpacedDivider size="xs" />
              <Lists
                actions={actions}
                collection={collection}
                {...listProps}
              />
            </SpacedPaper>
            <Spacer />
          </React.Fragment >
        )
      })}
    </>
  )
}

function SecondaryCollection({ collection, actions }) {
  return (
    <>
      {collection.length > 0 && (
        <SpacedPaper>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
            <HeaderPrimary>
              Imported, ready to play
            </HeaderPrimary>
            <ImportedReady />
          </Box>
          <SpacedDivider size="xs" />
          <Lists
            actions={actions}
            collection={collection}
            {...listProps}
          />
        </SpacedPaper>
      )}
    </>
  )
}

export function ImportSelection({
  primaryCollection = [],
  primaryActions = [],
  secondaryActions = [],
  secondaryCollection = [],
}) {
  return (
    <Grid container spacing={SPACING}>
      {primaryCollection.length > 0 && (
        <Grid item xs={12} sm={12} md={true} lg={true}>
          <Slide in direction="right" timeout={400}>
            <Box>
              <PrimaryCollection collection={primaryCollection} actions={primaryActions} />
            </Box>
          </Slide>
        </Grid>
      )}
      <Grid item xs={12} sm={12} md={true} lg={true}>
        <Slide in direction='left' timeout={400}>
          <Box>
            <SecondaryCollection collection={secondaryCollection} actions={secondaryActions} />
          </Box>
        </Slide>
      </Grid>
    </Grid>
  )
}

export default ImportSelection
